import { $t } from 'hooks/i18n';
import { BreadCrumb } from 'primereact/breadcrumb';
import { Button } from 'primereact/button';
import { Column } from 'primereact/column';
import { DataSource } from 'components/DataSource';
import { DataTable } from 'primereact/datatable';
import { Dropdown } from 'primereact/dropdown';
import { ExportPageData } from 'components/ExportPageData';
import { FilterTags } from 'components/FilterTags';
import { InputText } from 'primereact/inputtext';
import { PageRequestError } from 'components/PageRequestError';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Title } from 'components/Title';
import useUtils from 'hooks/useUtils';

import useListPage from 'hooks/useListPage';
const EmployeeleavehistoryvwListPage = (props) => {
		const utils = useUtils();
	const filterSchema = {
		financialyear: {
			tagTitle: $t('financialyear'),
			value: '',
			valueType: 'single',
			options: [],
		},
		empcode: {
			tagTitle: $t('empcode'),
			value: '',
			valueType: 'single',
			options: [],
		},
		search: {
			tagTitle: $t('search'),
			value: '',
			valueType: 'single',
			options: [],
		}
	}
	const pageController = useListPage(props, filterSchema);
	const filterController = pageController.filterController;
	const { records, pageReady, loading, apiUrl, sortBy, sortOrder, apiRequestError, getPageBreadCrumbs, onSort, pagination } = pageController;
	const { filters, setFilterValue, setFilterOptions } = filterController;
	const { totalPages, currentPage, limit, setPrevPage, setNextPage } =  pagination;
	function DateFromTemplate(data){
		if(data){
			return (
				<>{utils.humanDate( data.date_from )}</>
			);
		}
	}
	function DateToTemplate(data){
		if(data){
			return (
				<>{utils.humanDate( data.date_to )}</>
			);
		}
	}
	function PageLoading(){
		if(loading){
			return (
				<>
					<div  className="flex align-items-center justify-content-center text-gray-500 p-3">
						<div><ProgressSpinner style={{width:'30px', height:'30px'}} /> </div>
						<div  className="font-bold text-lg">{$t('loading')}</div>
					</div>
				</>
			);
		}
	}
	function EmptyRecordMessage(){
		if(pageReady && !records.length){
			return (
				<div className="text-lg mt-3 p-3 text-center text-400 font-bold">
					{$t('noRecordFound')}
				</div>
			);
		}
	}
	function ExportData() {
		if (props.exportData && records.length) {
			const downloadFileName = `${utils.dateNow()}-employeeleavehistoryvw`;
			return (
				<div className="m-2">
					<ExportPageData  pageUrl={apiUrl} downloadFileName={downloadFileName} butonLabel={$t('')} tooltip={$t('export')} buttonIcon="pi pi-print" />
				</div>
			);
		}
	}
	function PagerControl() {
		if (props.paginate && totalPages > 1) {
	return (
		<div className="flex-grow-1">
			<div className="flex  justify-content-center">
				<div  className="m-2">
					<Button disabled={pagination.currentPage <= 1} label="Previous" onClick={()=>pagination.setPrevPage()} icon="pi pi-arrow-left" />
				</div>
				<div className="m-2">
					<Button disabled={pagination.currentPage >= totalPages} label="Next" onClick={()=>pagination.setNextPage()} icon="pi pi-arrow-right" icon-pos="right" />
				</div>
			</div>
		</div>
	)
		}
	}
	function PageActionButtons() {
		return (
			<div className="flex flex-wrap">
				<ExportData />
			</div>
		);
	}
	function PageFooter() {
		if (pageReady && props.showFooter) {
			return (
				<div className="flex flex-wrap">
					<PageActionButtons />
					<PagerControl />
				</div>
			);
		}
	}
	function PageBreadcrumbs(){
		if(props.showBreadcrumbs) {
			const items = getPageBreadCrumbs();
			return (items.length > 0 && <BreadCrumb className="mb-3" model={items} />);
		}
	}
	if(apiRequestError){
		return (
			<PageRequestError error={apiRequestError} />
		);
	}
	return (
<main id="EmployeeleavehistoryvwListPage" className="main-page">
    { (props.showHeader) && 
    <section className="page-section mb-3" >
        <div className="container-fluid">
            <div className="grid justify-content-between align-items-center">
                <div className="col " >
                    <Title title={$t('employeeleavehistoryVw')}   titleClass="text-2xl text-primary font-bold" subTitleClass="text-500"      separator={false} />
                </div>
                <div className="col-12 md:col-3 comp-grid" >
                    <div className="p-3 mb-3">
                        <DataSource onLoad={(options) => setFilterOptions('financialyear', options)}  apiPath="components_data/financialyear_option_list"  >
                            {
                            ({ response }) => 
                            <>
                            <Title title={$t('filterByFinancialyear')}  headerClass="p-3" titleClass="font-bold text-primary" subTitleClass="text-sm text-500"      separator={false} />
                            <div className="">
                                <Dropdown filter={true} className="w-full" onChange={(e) => setFilterValue( 'financialyear', e.value)} value={filters.financialyear.value} optionLabel="label" optionValue="value" options={filters.financialyear.options} placeholder={$t('selectAValue')} >
                                </Dropdown>
                            </div>
                            </>
                            }
                        </DataSource>
                    </div>
                </div>
                <div className="col-12 md:col-3 comp-grid" >
                    <div className="p-3 mb-3">
                        <DataSource onLoad={(options) => setFilterOptions('empcode', options)}  apiPath="components_data/empcode_option_list_2"  >
                            {
                            ({ response }) => 
                            <>
                            <Title title={$t('filterByEmpcode')}  headerClass="p-3" titleClass="font-bold text-primary" subTitleClass="text-sm text-500"      separator={false} />
                            <div className="">
                                <Dropdown filter={true} className="w-full" onChange={(e) => setFilterValue( 'empcode', e.value)} value={filters.empcode.value} optionLabel="label" optionValue="value" options={filters.empcode.options} placeholder={$t('selectAValue')} >
                                </Dropdown>
                            </div>
                            </>
                            }
                        </DataSource>
                    </div>
                </div>
                <div className="col-12 md:col-3 " >
                    <span className="p-input-icon-left w-full">
                    <i className="pi pi-search" />
                    <InputText placeholder={$t('search')} className="w-full" value={filters.search.value}  onChange={(e) => setFilterValue('search', e.target.value)} />
                    </span>
                </div>
            </div>
        </div>
    </section>
    }
    <section className="page-section " >
        <div className="container-fluid">
            <div className="grid ">
                <div className="col comp-grid" >
                    <FilterTags filterController={filterController} />
                    <div >
                        <PageBreadcrumbs />
                        <div className="page-records">
                            <DataTable 
                                lazy={true} 
                                loading={loading} 
                                value={records} 
                                dataKey="leavedetailid" 
                                sortField={sortBy} 
                                sortOrder={sortOrder} 
                                onSort={onSort}
                                className=" p-datatable-sm" 
                                stripedRows={true}
                                showGridlines={false} 
                                rowHover={true} 
                                responsiveLayout="stack" 
                                emptyMessage={<EmptyRecordMessage />} 
                                >
                                {/*PageComponentStart*/}
                                <Column  field="leavedetailid" header={$t('leavedetailid')}  sortable={true} ></Column>
                                <Column  field="leavetypename" header={$t('leavetypename')}  sortable={true} ></Column>
                                <Column  field="date_from" header={$t('dateFrom')} body={DateFromTemplate} sortable={true} ></Column>
                                <Column  field="date_to" header={$t('dateTo')} body={DateToTemplate} sortable={true} ></Column>
                                <Column  field="apply_for_days" header={$t('applyForDays')}  sortable={true} ></Column>
                                <Column  field="approved_for_days" header={$t('approvedForDays')}  sortable={true} ></Column>
                                <Column  field="financialyear" header={$t('financialyear')}  sortable={true} ></Column>
                                <Column  field="status" header={$t('status')}  sortable={true} ></Column>
                                <Column  field="remarks" header={$t('remarks')}  sortable={true} ></Column>
                                <Column  field="empcode" header={$t('empcode')}  sortable={true} ></Column>
                                {/*PageComponentEnd*/}
                            </DataTable>
                        </div>
                        <PageFooter />
                    </div>
                </div>
            </div>
        </div>
    </section>
</main>
	);
}
EmployeeleavehistoryvwListPage.defaultProps = {
	primaryKey: '',
	pageName: 'employeeleavehistoryvw',
	apiPath: 'employeeleavehistoryvw/index',
	routeName: 'employeeleavehistoryvwlist',
	msgBeforeDelete: $t('promptDeleteRecord'),
	msgTitle: $t('deleteRecord'),
	msgAfterDelete: $t('recordDeletedSuccessfully'),
	showHeader: true,
	showFooter: true,
	paginate: true,
	isSubPage: false,
	showBreadcrumbs: true,
	exportData: true,
	importData: false,
	keepRecords: false,
	multiCheckbox: false,
	search: '',
	fieldName: null,
	fieldValue: null,
	sortField: '',
	sortDir: '',
	pageNo: 1,
	limit: 50,
}
export default EmployeeleavehistoryvwListPage;
